<template>
    <div class="applyResult">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="container" v-if="applyList.length">
            <div class="list" v-for="item in applyList" :key="item.id" >
                <div class="top" :class="{'success': item.auditStatus === 1, 'failed': item.auditStatus === 2}">申请赎回-{{ item.auditStatus === 1 ? '成功' : '失败' }}<span>{{ item.applyTime | formatDate }}</span></div>
                <div class="buttom" v-if='item.auditStatus === 1'>¥ {{ item.fee }}</div>
                <div class="buttom" v-else>{{ item.remark }}</div>
            </div>
        </div>
        <div class="msg" v-if="!applyList.length">
            <div class="img"><img src="../../../../assets/img/b2b/img_empty.png" alt=""></div>
            暂无数据
        </div>
        <div class="explain">
            <img src="../../../../assets/img/b2b/explain.png" alt="">
        </div>
    </div>
</template>

<script>
import Header from '../../../common/header'
import { getRansomResult } from '../../api/payment'
export default {
    name: 'applyResult',
    components: {
        Header
    },
    data () {
        return {
            title: '申请结果',
            userInfo: '',
            applyList: []
        }
    },
    methods: {
        onBack () {
            this.$router.back(-1)
        },
        async init () {
            const { data } = await getRansomResult({
                companyCode: this.userInfo.companyCode
            })
            this.applyList = data
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.init()
    }
}
</script>

<style lang="scss" scoped>
    .container{
        margin-top: 20px;
        background: #ffffff;
        padding-left: 32px;
        .list{
            padding: 32px 32px 32px 56px;
            font-weight: 400;
            .top{
                font-size: 32px;
                line-height: 44px;
                color: #000000;
                margin-bottom: 24px;
                position: relative;
                display: flex;
                justify-content: space-between;
                span{
                    font-size: 24px;
                    color: #666666;
                }
                &.success::before{
                    content: '';
                    position: absolute;
                    width: 40px;
                    height: 40px;
                    background: url('../../../../assets/img/b2b/refundSuccess.png') no-repeat;
                    background-size: 100% 100%;
                    top: 2px;
                    left: -56px;
                }
                &.failed::before{
                    content: '';
                    position: absolute;
                    width: 40px;
                    height: 40px;
                    background: url('../../../../assets/img/b2b/refundFailed.png') no-repeat;
                    background-size: 100% 100%;
                    top: 2px;
                    left: -56px;
                }
            }
            .buttom{
                font-size: 32px;
                color: #666666;
            }
            &:not(:last-child) {
                border-bottom: 1px solid #D1D1D6;
            }
        }
    }
    .explain{
        padding: 160px 0;
    }
    .msg {
        background: #ffffff;
        text-align: center;
        padding: 100px 0;
        color: #cccccc;
        .img{
            text-align: center;
            padding-bottom: 50px;
        }
    }
</style>